import {
  WithdrawsModel,
  WithdrawStatus,
  WithdrawStatusIcons,
  WithdrawStatusTitles,
} from '@/features/withdraws/model'
import { ItemLayout, PayoutIcon } from '@/shared/components'
import { useIsMobile } from '@/shared/utils'
import { formatCurrency } from '@/shared/lib'
import { Currencies } from '@/entities/curency'
import { CopyBlock } from '@/shared/components/CopyBlock/CopyBlock'

export const PayoutHeader = ({
  data,
  currencyRub,
  currencyUsdt,
  currencyRubFact,
  currencyUsdtFact,
}: {
  data: WithdrawsModel
  currencyRub?: number
  currencyUsdt?: number
  currencyRubFact?: number
  currencyUsdtFact?: number
}) => {
  const isMobile = useIsMobile()
  const usdt = currencyUsdtFact ? currencyUsdtFact : currencyUsdt
  const timeLeft = [
    WithdrawStatus.WaitingProcessing,
    WithdrawStatus.InProgress,
    WithdrawStatus.PayingRightNow,
  ].includes(data.withdrawStatus)
    ? data.payingAllowedTill
    : undefined

  const timeStatus = [WithdrawStatus.WaitingProcessing].includes(data.withdrawStatus)
    ? 'pending'
    : [WithdrawStatus.InProgress, WithdrawStatus.PayingRightNow].includes(data.withdrawStatus)
      ? 'inProgress'
      : undefined

  return (
    <div className="flex justify-between items-center">
      <ItemLayout
        icon={
          <PayoutIcon
            status={WithdrawStatusIcons[data.withdrawStatus]}
            className="md:w-[52px] md:h-[52px]"
          />
        }
        title={WithdrawStatusTitles[data.withdrawStatus]}
        subtitle={
          <div className="flex flex-col">
            <CopyBlock text={data?.id} title={data?.id} color="secondary">
              ID: {data?.id}
            </CopyBlock>
            {data?.requestId && (
              <CopyBlock text={data?.requestId} title={data?.requestId} color="secondary">
                ID request: {data?.requestId}
              </CopyBlock>
            )}
          </div>
        }
        titleClasses="text-[20px] md:text-[32px] mr-[10px]"
        subtitleClasses="font-medium text-sm"
        timeLeft={timeLeft}
        statusForTime={timeStatus}
      />
      {!isMobile && (
        <div className="flex flex-col items-end">
          {usdt && (
            <CopyBlock text={usdt?.toFixed(2)} size="base" className="text-[32px]">
              {formatCurrency(usdt, Currencies.USDT)}
            </CopyBlock>
          )}
          {currencyRubFact && (
            <CopyBlock text={currencyRubFact.toFixed(2)} color="secondary">
              Сумма поступления: {formatCurrency(currencyRubFact, Currencies.RUB)}
            </CopyBlock>
          )}
          {currencyRub && (
            <CopyBlock text={currencyRub.toFixed(2)} color="secondary">
              Сумма сделки: {formatCurrency(currencyRub, Currencies.RUB)}
            </CopyBlock>
          )}
        </div>
      )}
    </div>
  )
}
